module.exports = __webpack_public_path__ + "static/img/07.ba75f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/07.png
// module id = mLfL
// module chunks = 1